'use client'

import React, { useEffect } from 'react'
import { Button } from '@/components/ui/button'
import { getClientIPAddress } from '@/lib/utils'
import { postSessionLogout } from '@/services/auth'
import { useLogoutData } from '@/contexts/LogoutContext'
import { useRouter, useSearchParams } from 'next/navigation'
import CustomTable from '@/components/custom-table/CustomTable'

import {
  statusList,
  getDataList,
  getStatusIcon,
  getStatusFromPaymentCode,
  getStatusTitleAndDescription
} from '../appConstants'

const HomeClientComponent = () => {
  const searchParams = useSearchParams()
  const {
    campus,
    studentId,
    name,
    acadProg,
    acadProgDescr,
    invoiceNumber,
    totalAmount,
    paymentCode,
    email,
    statusCode,
    sessionId
  } = Object.fromEntries(searchParams.entries())
  const { logoutData, setLogoutData } = useLogoutData()

  const status = getStatusFromPaymentCode(statusCode)
  const { title, description } = getStatusTitleAndDescription(status, email, paymentCode)

  const router = useRouter()
  const handleLogout = async () => {
    try {
      if (logoutData) {
        await postSessionLogout({
          emplid: logoutData.studentId,
          ipAddress: logoutData.ipAddress,
          sessionId: logoutData.sessionId,
          loginStatus: 'N'
        })
      }

      // Redirect to configured logout URL or default to home page
      const logoutRedirectUrl = process.env.NEXT_PUBLIC_LOGOUT_REDIRECT_URL || '/'
      router.push(logoutRedirectUrl)
    } catch (error) {
      console.error('Logout error:', error)

      // Stay on current page by refreshing
      router.refresh()
    }
  }

  useEffect(() => {
    const setupLogoutData = async () => {
      const ipAddress = await getClientIPAddress()
      setLogoutData({
        studentId,
        ipAddress,
        sessionId
      })
    }

    if (studentId && sessionId) {
      setupLogoutData()
    }
  }, [ studentId, sessionId, setLogoutData ])

  return (
    <div className='w-full h-full'>
      {/* STATUS ICON */}
      <div className='w-full flex flex-col items-center gap-2 my-8 rounded-full'>
        <div className='rounded-full bg-white border p-2'>{getStatusIcon(status)}</div>
        <h1 className='text-3xl font-semibold text-center'>{title}</h1>
        <h1 className='text-xl text-center'>{description}</h1>
      </div>

      {/* TABLE */}
      <CustomTable data={getDataList(campus, studentId, name, `${acadProg ?? ''} - ${acadProgDescr ?? ''}`, invoiceNumber, totalAmount)} />

      {status === statusList[2] && (
        <div className='w-full py-8 flex justify-center'>
          <Button className='hover:cursor-pointer' onClick={handleLogout}>FINISH</Button>
        </div>
      )}
    </div>
  )
}

export default HomeClientComponent
